import { GameState, gameStates, getGameStateById } from './machine/state-types';
import { backend, handlePlayError } from '@src/backend';
import { get } from 'svelte/store';
import { assert, getLongFormatNumber, getVideoUrl } from '@src/utils/global';
import {
    allowToBet,
    allowToSkip,
    autoBetCount,
    autoBetStarted,
    gameRoundInfo,
    gameStatus,
    isUndoResetHistory,
    unformattedBalance,
    videoUrl,
    videosFiltered,
    roundTime,
    skipHappen
} from '@src/store';
import { getBetPerColor } from '../betting/betting';
import { getIndexOfFirstResolved, startAuto, wait, waitForEmitterEvent, waitForPlayClick } from './machine/helpers';
import { showBonusGameTransition, showTopSlot } from '../store/ui';
import { EventEmitterInstance } from '../utils/event-emitter';
import { playAudio } from '../utils/audio';
import { gameInitParams } from '../store/misc';
import { chipPrice } from '../store/chips';
import dayjs from 'dayjs';
import { updateHistoryLine } from '../store/game-history';

export const state: GameState = {
    name: gameStates.game,
    onEnter: async setState => {
        console.log('Game state');
        EventEmitterInstance.on('start-auto-bet', startAuto);

        let timerWinSound = null;

        skipHappen.set(false);

        let abs = get(autoBetStarted);
        const abc = get(autoBetCount);
        if (abs && abc <= 0) {
            abs = false;
            autoBetStarted.set(false);
            autoBetCount.set(0);
        }

        if (abs) {
            await wait(1000);
            autoBetCount.set(abc - 1);
        } else {
            gameStatus.set('PLACE_BET');
            allowToBet.set(true);
            await waitForPlayClick();
        }
        roundTime.update($roundTime => ({ ...$roundTime, from: dayjs() }));

        allowToBet.set(false);
        allowToSkip.set(true);
        gameStatus.set('STARTED');

        //TODO take bet from betting system
        const $videosFiltered = get(videosFiltered);
        const { exponent } = get(gameInitParams).currency_attributes;
        const $chipPrice = Number(get(chipPrice));
        if (isNaN($chipPrice)) throw new Error('chip price is not number');

        const bets = getBetPerColor().map(val => getLongFormatNumber(val, exponent));
        let totalBet = 0;
        for (const bet of bets) {
            totalBet += bet;
        }
        const deductedBalanceMinusBet = get(unformattedBalance) - totalBet * $chipPrice;

        const play = await backend.play(bets).catch(handlePlayError);
        if (!play || !play.resp) {
            setState(gameStates.game);
            return;
        }

        EventEmitterInstance.emit('analytics-make-bet');
        unformattedBalance.set(deductedBalanceMinusBet);
        isUndoResetHistory.set(true);

        gameRoundInfo.set(play);

        const { win, win_amount, win_type } = play?.resp;

        const colorTitle = play?.resp?.color?.toLowerCase();

        if (!colorTitle) assert('missing ball color');

        const url = getVideoUrl($videosFiltered, colorTitle, win);

        videoUrl.set(url);

        //Ждем скипа или окончания видео
        const choice = await getIndexOfFirstResolved([
            waitForEmitterEvent('round-video-finish'),
            waitForEmitterEvent('skip-game')
        ]);

        if (timerWinSound) clearTimeout(timerWinSound);
        if (win) {
            timerWinSound = setTimeout(() => {
                playAudio('audio_win_reaction');
            }, 2500);
        }

        allowToSkip.set(false);

        videoUrl.set(''); //FIXME если не обнулять, раунд играется повторно, после бонусной игры

        if (play.resp.bonus_game) {
            showBonusGameTransition.set(true);
            setState(getGameStateById(play.resp.bonus_game));
            return;
        }

        EventEmitterInstance.emit('top-slot-startTrigger');
        showTopSlot.set(false);

        if (win) {
            // Если выигрыш показывать bigwin
            console.log('win ' + win_amount + ' type ' + win_type);
            setState(gameStates.bigWin);
            return;
        } else {
            EventEmitterInstance.emit('analytics-game-finished', false, 0);
            updateHistoryLine({
                win: false,
                multiplier: null,
                bonus_game_type: play?.resp?.bonus_game,
                color: play?.resp?.color
            });
        }

        // wait if player decided to skip round
        if (choice.index === 1) await wait(700);

        setState(gameStates.game);
    },
    onExit: () => {
        EventEmitterInstance.off('start-auto-bet', startAuto);
    }
};
